import Project from '@/classes/projects/Project'

export default class Projects extends Array {
  constructor (projects, ...rest) {
    Array.isArray(projects) ? super(...projects.map(project => new Project(project))) : super(...rest)
  }

  get (id) {
    return this.find(project => project.id === id)
  }
}
